import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Microbiologia`, method: 'GET', body: null, token: token})
}
